import React, { Component } from 'react';
import '../App.scss';
import DBConfig from '@CONFIG';

class Home extends Component {
  render() {
    return (
      <div>
        <h2>HELLO</h2>
        <p>Welcome Main Page</p>
        <div>
          <a href='/userProfile/1'>点击进入profile</a>
        </div>
        <div>
          <a href={`/activity/${DBConfig.defaultActivityId}`}>
            点击进入动态详情页
          </a>
        </div>
        <p>Let's work togother.</p>
      </div>
    );
  }
}

export default Home;
